<script lang="ts">
    import { emptyPodcast } from "../scripts/classes/podcast";

    export let props = {
        podcast: emptyPodcast
    };

</script>

<style lang="scss">

    .podcastInsight {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        border-radius: 20px 20px 20px 20px;
        background-color: $color_primary;
        color: $color_secondary;
        padding: 20px;
        margin: 40px 0 40px 0;
        &__withborder {
            border: 5px solid $color_secondary;
        }
        &__image {
            object-position: center;
            width: 100%;
            height: 100%;
            max-height: 200px;
            border-radius: 10px;
            margin: 0 0 40px 0;
        }
        &__h2 {
            line-height: 1.3em;
            font-size: 30px;
            z-index: 1;
            color: $color_secondary;
        }
        &__h3 {
            font-size: 20px;
            z-index: 1;
            color: $color_secondary;
        }
        &__text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0 0 0 0;
            text-align: center;
        }
    }

    @include large {

        .podcastInsight {
            display: grid;
            grid-template-columns: 60% 40%;
            gap: 10px 10px;
            width: 100%;
            transition: all 0.5s;
            cursor:pointer;
            margin: 0 0 50px 0;
            &:hover {
                border: 5px $color_tertiary;
                box-shadow: 5px 5px 40px 5px $color_secondary;
            }
            &__image {
                width: auto;
                margin: 0 0 0 0;
            }
            &__h2 {
                font-size: 30px;
                z-index: 1;
                color: $color_secondary;
            }
            &__h3 {
                font-size: 20px;
                z-index: 1;
                color: $color_secondary;
            }
            &__text {
                align-items: flex-start;
                padding: 0 0 0 30px;
            }
        }
    }

</style>

<div class="podcastInsight">
    <div class="podcastInsight__image">
        <img class="podcastInsight__image" src="../assets/images/podcasts/{props.podcast.id}_{props.podcast.photo_file_name}" alt="aperçu podcast">
    </div>
    <div class="podcastInsight__text">
        <h2 class="podcastInsight__h2">{props.podcast.title}</h2>
        <h3 class="podcastInsight__h3">{props.podcast.subtitle}</h3>
        <div class="link"></div>
    </div>
</div>